<ng-container *ngIf="isSidebarExpanded$ | async as isSidebarExpanded">
  <header
    class="h-60px w-full flex {{
      sidebarS.isMobileView ? 'justify-between px-16px' : 'justify-center'
    }}  items-center"
  >
    <a routerLink="/">
      <ib-logo-name-horizontal
        *ngIf="sidebarS.isMobileView"
        class="w-160px"
      ></ib-logo-name-horizontal>
      <ng-container *ngIf="!sidebarS.isMobileView">
        <ib-logo *ngIf="!isSidebarExpanded.v" class="w-40px"></ib-logo>
        <ib-logo-name-horizontal
          *ngIf="isSidebarExpanded.v"
          class="w-160px"
        ></ib-logo-name-horizontal>
      </ng-container>
    </a>

    <button type="button" class="flex" *ngIf="bpS.isSm" (click)="closeMenu()">
      <i class="material-icons text-24px !text-white">close</i>
    </button>
  </header>

  <nav
    [@.disabled]="isAnimDisabled"
    class="flex flex-col grow justify-start pb-24px pt-40px md:pt-0"
  >
    <a
      *ngFor="let item of routeItems"
      [routerLink]="item.routePath"
      routerLinkActive="active"
      (click)="sidebarS.isMobileView ? sidebarS.toggleSidebar() : null"
      class="mt-5"
      class="px-16px border-l-4 flex justify-start items-center h-sidebar-collapse text-txt-nav text-12px"
      [routerLink]="item.route"
    >
      <i
        class="material-icons {{
          isSidebarExpanded.v ? 'text-16px' : 'text-18px'
        }} "
        >{{ item.icon }}</i
      >
      <span
        *ngIf="isSidebarExpanded.v"
        [@opacityIn300ms]="'in'"
        class="flex ml-8px text-14px whitespace-nowrap"
        >{{ item.title | transloco }}</span
      >
    </a>
  </nav>
</ng-container>
